import ThemeContext from "config/context/themeContext";
import { useContext } from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";

const NotFound = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <main
      className={`column align-center justify-center ${
        dark ? styles.dark : ""
      } ${styles.notFound}`}
    >
      <div className="column align-center gap-2">
        <div className="text-center">
          <h1 className={styles.title}>404</h1>
          <p>The requested page is not available</p>
        </div>
        <Link to="/dashboard">Go to Dashboard</Link>
      </div>
    </main>
  );
};

export default NotFound;
